<template>
  <div class="add-edit-page">
    <myHeader :title="title">
      <!-- <span slot="right-sum"
            class="save-address"
            @click.stop="saveAdd">保存</span> -->
    </myHeader>
    <section class="content">
      <div>
        <p>姓名</p>
        <input type="text"
               placeholder="必填，最多输入25个汉字"
               v-model="params.user_name" />
      </div>
      <div>
        <p>手机号</p>
        <input type="number"
               placeholder="请输入手机号"
               v-model="params.mobile" />
      </div>
      <div>
        <p>地址信息</p>
        <input type="text"
               readonly
               placeholder="请选择省/市/区/街道"
               @click="requestArea"
               v-model="city" />
      </div>
      <div>
        <p>详细地址</p>
        <textarea v-model="params.address"
                  placeholder="请输入详细地址，如道路、门牌号、校区、楼栋数、单元等"></textarea>
      </div>
    </section>
    <div class="save-address"
            @click.stop="saveAdd">保存</div>
    <!-- <van-cell class="default-add"
              title="设为默认地址">
      <van-switch active-color="#2FC19A"
                  slot="default"
                  v-model="defaults"
                  @change="changeDefault" />
    </van-cell> -->
    <!-- <van-cell v-if="id"
              @click="deleteAdd"
              title="删除收货地址"></van-cell> -->
    <van-popup v-model="showPopup"
               position="bottom">
      <van-area :area-list="areaList"
                :columns-num="3"
                @change="onChangeAddress"
                @cancel="showPopup=false"
                @confirm="onConfirmAddress"
                :value="params.district_id + ''" />
    </van-popup>
  </div>
</template>

<script>
import myHeader from "@/components/Header";
export default {
  name: "AddressEdit",
  components: {
    myHeader
  },
  data () {
    return {
      title: {
        name: "添加收货地址"
      },
      defaults: false,
      params: {
        user_name: "",
        mobile: "",
        address: "",
        province_id: "",
        city_id: "",
        district_id: ""
      },
      areaList: {
        province_list: {},
        city_list: {},
        county_list: {}
      },
      showPopup: false,
      city: "",
      id: this.$route.query.id || ""
    };
  },
  methods: {
    async changeDefault () {
      if (this.id) {
        await this.$http.put(`/api/app/address/status/${this.id}`);
      }
    },
    async deleteAdd () {
      await this.$http.delete(`/api/app/address/${this.id}`);
      if (this.$store.state.app) {
        this.$pub.appAction("closeAppPage");
      } else{
        this.$router.go(-1);
      }
    },
    async saveAdd () {
      if (this.id) {
        if (this.$route.query.order_address_id) {//修改收货地址
          this.params.id = this.$route.query.order_address_id;
          this.params.consignee = this.params.user_name;
          await this.$http.put(`/api/app/myOrder/childOrderAddress`, {
            ...this.params,
            is_default: this.defaults ? 1 : 2
          });
        } else {
          await this.$http.put(`/api/app/address/${this.id}`, {
            ...this.params,
            is_default: this.defaults ? 1 : 2
          });
        }
      } else {
        await this.$http.post("/api/app/address", {
          ...this.params,
          is_default: this.defaults ? 1 : 2
        });
      }
      this.$router.go(-1);
    },
    onConfirmAddress (val) {
      this.showPopup = false;
      this.params.province_id = val[0].code;
      this.params.city_id = val[1].code;
      this.params.district_id = val[2].code;
      this.city = val[0].name + val[1].name + val[2].name;
    },
    async requestArea () {
      let obj = {};
      const province = await this.$http.get("/api/app/sonArea/0");
      province.forEach(i => {
        obj[i.id] = i.area_name;
      });
      this.areaList.province_list = obj;
      const provinceID = this.params.province_id || province[0].id;
      const city = await this.$http.get(`/api/app/sonArea/${provinceID}`);
      obj = {};
      city.forEach(i => {
        obj[i.id] = i.area_name;
      });
      this.areaList.city_list = obj;
      const cityID = this.params.city_id || city[0].id;
      const district = await this.$http.get(`/api/app/sonArea/${cityID}`);
      obj = {};
      district.forEach(i => {
        obj[i.id] = i.area_name;
      });
      this.areaList.county_list = obj;
      //   console.log(district[0].id);
      //   if (!this.params.district_id && district.length) {
      //     this.params.district_id = district[0].id;
      //   }
      this.showPopup = true;
    },
    async onChangeAddress (picker, data, index) {
      switch (index) {
        case 0: // province
          {
            const province = await this.$http.get(
              `/api/app/sonArea/${data[index].code}`
            );
            let obj = {};
            province.forEach(i => {
              obj[i.id] = i.area_name;
            });
            this.areaList.city_list = obj;
            const city = await this.$http.get(
              `/api/app/sonArea/${province[0].id}`
            );
            obj = {};
            city.forEach(i => {
              obj[i.id] = i.area_name;
            });
            this.areaList.county_list = obj;
          }
          break;
        case 1: // city
          {
            const city = await this.$http.get(
              `/api/app/sonArea/${data[index].code}`
            );
            let obj = {};
            city.forEach(i => {
              obj[i.id] = i.area_name;
            });
            this.areaList.county_list = obj;
          }
          break;
        case 2: // county
          break;
      }
    }
  },
  async created () {
    if (this.id) {
      let data = await this.$http.get(`/api/app/address/${this.id}`);
      for (let i in this.params) {
        this.params[i] = data[i];
      }
      this.city =
        data.province_name + data.city_name + data.district_name + data.address;
      this.defaults = data.is_default == 1 ? true : false;
      this.title.name = "编辑收货地址";
    }
  }
};
</script>

<style lang="scss" scoped>
.add-edit-page {
  @extend %default-bg;
  .save-address {
    display: inline-block;
    width: 690px;
    margin: 100px 0 0 30px;
    background-color: $theme_color;
    font-size: 34px;
    color: #fff;
    border-radius: 10px;
    height: 88px;
    line-height: 88px;
    text-align: center;
  }
  .content {
    padding: 0 30px;
    background: #fff;
    margin-bottom: 20px;
    > div {
      padding: 30px 0;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      p {
        font-size: 28px;
        color: rgba(89, 89, 89, 1);
        line-height: 60px;
      }
      input {
        width: 100%;
        height: 80px;
        background: rgba(253, 253, 253, 1);
        border-radius: 4px;
        border: 2px solid rgba(232, 232, 232, 1);
        font-size: 28px;
        color: #595959;
        line-height: 80px;
        padding: 0 20px;
        box-sizing: border-box;
      }
      textarea {
        width: 100%;
        height: 128px;
        background: rgba(253, 253, 253, 1);
        border-radius: 4px;
        border: 2px solid rgba(232, 232, 232, 1);
        font-size: 28px;
        color: #595959;
        line-height: 44px;
        padding: 20px;
        box-sizing: border-box;
      }
      input::-webkit-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #b7b7b7;
      }
      input::-moz-placeholder,
      textarea::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #b7b7b7;
      }
      input:-moz-placeholder,
      textarea::-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #b7b7b7;
      }
      input:-ms-input-placeholder,
      textarea::-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #b7b7b7;
      }
    }
  }
  .van-cell__title {
    span {
      color: #ee1f1f;
    }
  }
  .default-add {
    margin-bottom: 20px;
    .van-cell__title {
      span {
        color: #595959;
      }
    }
  }

  .van-switch {
    margin-top: 17px;
  }
}
</style>
